import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {InfluencerService} from '../../services/influencer/influencer.service';
import {AppSettings} from '../../utils/app-settings';
import {PlaceholderVisibilityService} from '../../services/placeholder-visibility/placeholder-visibility.service';

@Component({
  selector: 'influencer-connection',
  templateUrl: './influencer-connection.component.html',
  styleUrls: ['./influencer-connection.component.scss']
})
export class InfluencerConnectionComponent implements OnInit {

  public isAccepted = false;
  public isProcessing = false;
  public isRejected = false;
  public influencerName: string;
  public advertiserName: string;
  public companyName: string;

  private permissionToken: string;

  constructor(private route: ActivatedRoute,
              private influencerService: InfluencerService,
              private placeholder: PlaceholderVisibilityService) { }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      if (params.token) {
        this.permissionToken = params.token;
        this.acceptPermission();
      }
    });
  }

  acceptPermission() {
    this.influencerService.acceptContactPermission(this.permissionToken).subscribe((res) => {
      this.influencerName = res.influencer_name;
      this.advertiserName = res.advertiser_name;
      this.companyName = res.agency_name;
      this.afterAcceptedPermission();
    });
  }

  private afterAcceptedPermission() {
    this.isAccepted = true;
    this.isRejected = false;
  }

  rejectPermission() {
    if (this.permissionToken) {
      this.influencerService.rejectContactPermission(this.permissionToken).subscribe((res) => {
        this.afterRejectedPermission();
      });
    }
  }

  private afterRejectedPermission() {
    this.isAccepted = false;
    this.isRejected = true;
  }

  get marketingLink() {
    return AppSettings.influencerProgramMarketingLink();
  }

  public openIntercom() {
    if (typeof (<any>window).Intercom === 'function') {
      (<any>window).Intercom('showMessages');
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/influencer-platform/influencer-connection/influencer-connection.component.ts